'use client';

import type { ReactNode, RefObject } from 'react';
import { HStack } from '@terra/ui-styled-system';
import { BodyDefault } from '../../../components/typography';
import { DocumentationFilesUploadSpinnerSlot } from './DocumentationFilesUploadSpinnerSlot';

type DocumentationSectionHeaderProps = {
  label: string;
  containerRef?: RefObject<HTMLDivElement | null>;
  badge?: ReactNode;
  isBusy: boolean;
  action: ReactNode;
};

export const DocumentationSectionHeader = ({
  label,
  containerRef,
  badge,
  isBusy,
  action,
}: DocumentationSectionHeaderProps) => (
  <HStack
    ref={containerRef}
    justifyContent="space-between"
    alignItems="center"
    w="full"
  >
    <HStack>
      <BodyDefault color="fg.neutral.muted">{label}</BodyDefault>
      {badge}
    </HStack>
    {action ? isBusy ? <DocumentationFilesUploadSpinnerSlot /> : action : null}
  </HStack>
);
